import { Component, OnInit, ViewChild, ElementRef, HostListener, Renderer2,ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router, RouterLink } from '@angular/router';
import { UserService } from '../../services/user.service';
import { NotificationService } from '../../services/notification.service';
import { ShareService } from '../../services/share.service';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { HeaderService } from '../../services/header.service';
import { SocketService } from '../../services/web/socket.service';
import { CourseService } from '../../services/course.service';
import { parentInter, courses_inFo } from '../../model/courseCategory';
import { finalize } from 'rxjs/internal/operators/finalize';
import { debounceTime, distinctUntilChanged, tap, filter } from 'rxjs/operators';
import { fromEvent, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { JobsService } from 'src/app/services/jobs.service';
import { error } from '@angular/compiler/src/util';
import { AuthorizationService } from 'src/app/services/authorization.service';
import { Roles as RolesConst } from 'src/app/auth/roles.enum';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent implements OnInit, OnDestroy {
  private readonly globalMessageCountStorageKey = 'global_message_count';

  @ViewChild('searchInput', {static: false}) searchInput: ElementRef;
  @ViewChild('headerSection', {static: false}) headerSection: ElementRef;

  navbarOpen = false;
  loginFlag = false;
  CategoriesCourse: boolean = true
  showNotiBx: boolean = false;
  listLoader:boolean = false;
  guftgu = 0;
  roles;
  countNumber:any;
  globalMessageCount: number = 0;
  pmenus = [
    {
      name: 'Courses',
      link: '/courses/ec-course-board',
      slug: 'read_org_public_courses/read_all_courses',
    },
    // {
    //   name: 'My Content',
    //   link: 'my-content',
    //   slug: 'my_content'
    // },
    // {
    //   name: 'Marking',
    //   link: 'marking',
    //   slug: 'marking'
    // },
  ];

  pmenusBL = [
    {
      name: 'Log In',
      link: 'login'
    }
  ];
  permission: [];
  userLogo: string;
  user_id: string;
  userName: string
  Email_ID: string
  userFirstName:string;
  userLastName:string;
  default_svg_project:string;
  default_svg_course:string;
  default_svg_profile:string;
  default_svg_guftagu:string;
  default_svg_calender:string;
  defaultAvtar:string;
  defaultAvtarGroup:string;
  notificationList:any[] = [];
  currentUrl:string = '';

  // For debounce API call
  private lastCallTimestamp: number | null = null;
  private readonly cooldownTime = 5 * 60 * 1000; // 5 minutes in milliseconds

  primaryColor: string;

  get role() {
    return localStorage.getItem('role');
  }
  get permissions() {
    return this.permission = JSON.parse(localStorage.getItem("permissions"));
  }
  result: [] = [];

  isProduction: boolean = environment.production;
  routerUrl:any;

  // FOR SET ORG LOGO
  orgLogoUrl: string = '';
  orgLogoSubs!: Subscription;
  isISDMOrg: boolean = false;

  cateLoader:boolean = false;

  //FOR ALLOWED ROLES TO VIEW JOBS IN HEADER
  allowedRoles: any[] = [RolesConst.TEACHER, RolesConst.MENTOR, RolesConst.SUPER_ADMIN, RolesConst.ORG_ADMIN];
  studentRole = RolesConst.STUDENT;

  constructor(public router: Router,
    private activatroute: ActivatedRoute,
    private shareService: ShareService,
    private userService: UserService,
    private ns: NotificationService,
    private route: Router,
    private socket_service: SocketService,
    ddConfig: NgbDropdownConfig,
    private courseService: CourseService,
    private headerService: HeaderService,
    private changeDetector:ChangeDetectorRef,
    private renderer: Renderer2,
    public perm: AuthorizationService) {
      this.default_svg_project = environment.svgBasePath + environment.default_Pic_project;
      this.default_svg_course = environment.svgBasePath + environment.default_Pic_course;
      this.default_svg_profile = environment.svgBasePath + environment.default_Pic_profile;
      this.default_svg_guftagu = environment.svgBasePath + environment.default_Pic_guftagu;
      this.default_svg_calender = environment.svgBasePath + environment.default_Pic_calender;

      this.defaultAvtar = environment.imageBasePath + environment.userDefaultProfilePic;
      this.defaultAvtarGroup = environment.imageBasePath + environment.userDefaultGroupPic;
    // ddConfig.autoClose = "outside";
    ddConfig.autoClose = true;
    if (localStorage.getItem('currentUser')) {
      this.loginFlag = true;
    }
    router.events.subscribe((val) => {
      if(val instanceof NavigationStart){
        this.currentUrl = val.url;
      }
    })

    this.result = this.findMenu(this.pmenus);
    this.lasestCount();
  }

  statOrders: string[] = ["Read", "Online", "Away"];
  selectedStatOrder: string = "Online";

  ChangeStatOrder(newStatOrder: string) {
    this.selectedStatOrder = newStatOrder;
  }

  get getResult(): any {
    return this.result = this.findMenu(this.pmenus);
  }
  findMenu(arr) {
    return arr.filter(function (ele) {
      if (localStorage.getItem('role') == 'student' && (ele.link != ("bulk-upload") && ele.link != ("report") && ele.link != ("addUser") && ele.link != ("manageRoles") && ele.link != ("question-bank"))) {
        return ele;
      } else if (localStorage.getItem('role') == 'teacher' && (ele.link != ("bulk-upload") && ele.link != ("report") && ele.link != ("manageRoles") && ele.link != ("addUser") && ele.link != ("my-content"))) {
        return ele;
      } else if (localStorage.getItem('role') == 'super_admin' || localStorage.getItem('role') == 'school_admin') {
        return ele;
      }
    });
  }

  ngOnInit() {
    this.globalMessageCount = this.getGlobalMessageCount();
    this.user_id = localStorage.getItem('user_id');
    this.userName = localStorage.getItem('currentUser')
    this.userFirstName = localStorage.getItem('first_name')
    this.userLastName = localStorage.getItem('last_name')
    this.Email_ID = localStorage.getItem('Email_ID')
    this.roles = localStorage.getItem('role')

    //SET SUBDOMAIN ORG LOGO IMAGE
    this.orgLogoSubs = this.headerService.orgLogo.subscribe((logoData: any) => {
      if(Object.keys(logoData).length > 0 && !logoData.isLargeLogo) {
        this.orgLogoUrl = logoData.logoimage;
      }
      this.isISDMOrg = logoData && logoData.organizationSubDomain ? logoData.organizationSubDomain.toLowerCase() === 'isdm' : false;
    });

    // Always refresh org branding so BehaviorSubject has latest value even after reloads
    this.userService.setOrgData();

    //SET LATEST AVATAR IMAGE ON PAGE RELOAD
    if('currentUser' in localStorage) {
      if('avatarURL' in localStorage) {
        this.headerService.getLatestAvatar().subscribe(res => {
          this.headerService.setLogo(res.profile_pic);
          localStorage.setItem('avatarURL', res.profile_pic);

          // To set org logo url
          const hasBranding = res && (res.is_subdomain || res.is_domain || res.org_image_url || res.organizationSubDomain || (res.image_data && Object.keys(res.image_data).length > 0));
          if (hasBranding) {
            this.userService.setLogoTheme(res);
          }

        }, err => {
          //console.log(err);
        });
      }
    }
    else {
      //SET SUBDOMAIN ORG LOGO IMAGE ON PAGE RELOAD
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd)
      ).subscribe((event: NavigationEnd) => {
        if(!event.url.includes('/login') && !event.url.includes('/forgot-password') && !event.url.includes('/reset-password')) {
          this.userService.setOrgData();
        }
      });
    }


    this.headerService.logo.subscribe(img => {
      if (!img) {
        this.userLogo = '';
      } else this.userLogo = img
    });

    //FOR SEARCH WITH QUERY PARAM
    this.activatroute.queryParams.subscribe({
      next: (params) => {
        if(this.router.url.indexOf('/search') != -1) {
          let routeParams = JSON.parse(JSON.stringify(params));
          if(Object.keys(routeParams).length > 0) {
            this.search_text = routeParams.q;
          }
        }
        else {
          this.search_text = '';
        }
        let sp = this.router.url.split('?')
        this.routerUrl = sp[0];
        
      }
    });


    if (localStorage.getItem('currentUser')) {
        this.headerService.notifyCountNumAs.subscribe((response:number)=>{
          this.notifyCount = response;
        })
        this.lasestCount();
        this.get_notify_status();
        this.getNotificationApiData();
            // this.sortedCourseCategory();
    }
   

    // For remove search text on pages other than mentorship
    this.router.events.pipe(filter(event => event instanceof NavigationEnd))
    .subscribe((event: NavigationEnd) => {
      if(event.url.indexOf('mentorship') == -1) {
        localStorage.removeItem('mentorSearchText');
      }
    });
  }

  ngAfterContentChecked() : void {
    this.changeDetector.detectChanges();
}


// after 5 mint api call
 onButtonClickCallCategory() {
    const now = Date.now();
    if (!this.lastCallTimestamp || now - this.lastCallTimestamp > this.cooldownTime) {
      this.sortedCourseCategory();
      this.lastCallTimestamp = now;
    } else {
      const remaining = Math.ceil((this.cooldownTime - (now - this.lastCallTimestamp)) / 1000);
      console.log(`Please wait ${remaining} seconds before trying again.`);
    }
  }


  getLastestNotify(){
    this.getNotificationApiData();
  }
  get_notify_status(){
    if(!this.user_id) {
      return;
    }
    this.socket_service.get_notification_data().subscribe((response)=>{
      response.receivers.filter((receiver:any)=>{
          if(receiver == this.user_id){
            this.notificationList.unshift({...response});
            this.getNotificationApiData();
          }
        })
    })
  }

  notifyCount:number = 0;
  getNotificationApiData(){
    if(!this.user_id) {
      return;
    }
    this.listLoader = true;
    this.notificationList = [];
    this.ns.getNotificationsDropDown().subscribe(response =>{
      let notificationsCount = response.count;
      this.headerService.SetNotifyCount(notificationsCount);
      this.notifyCount = notificationsCount;
      let notifications = response.notifications;
      notifications.forEach((notification:any)=>{
        notification.receivers.filter((receiver:any)=>{
          if(receiver == this.user_id){
            this.notificationList.push(notification);
          }
        })
      })
      this.listLoader = false;
    })
  }


  redirectTo(NotifiyData){
    this.readNotifyMethod(NotifiyData._id);   
    if(NotifiyData.type == 'messages'){
      this.headerService.SetNotifyEvent(true);      
      if(NotifiyData.content.group_chat == false){
        this.router.navigate(['/guftagu'], { queryParams:{ chatRoomId:NotifiyData.content.room_id}})
      } else if(NotifiyData.content.group_chat == true){
        this.router.navigate(['/guftagu'], { queryParams:{ group_room_id:NotifiyData.content.room_id}})
      }
    } else if(NotifiyData.type == 'chat_request'){
      this.headerService.SetNotifyEvent(true);      
      this.router.navigate(['/guftagu'], { queryParams:{ rq_sender_id:NotifiyData.content.sender_id}})
    } else if(NotifiyData.type == 'chat_invite'){
      this.router.navigate(['/guftagu']);
    } else if(NotifiyData.type == 'calendar_reminders_or_tasks'){
      this.router.navigate(['/schedules'])
    } else if(NotifiyData.type == 'TA_assignment'){
        this.router.navigate(['/courses/single-course'], { queryParams:{ course_id:NotifiyData.content.course_id , tab_no:4}})
    } else if(NotifiyData.type == 'AI_assessment'){
      localStorage.setItem('ngbNavItem', '5');
      localStorage.setItem('active_tab_assessment', 'unApprovedAssessment')
      this.router.navigate(['/courses/video-with-notes'], { queryParams:{ 
        course_id: NotifiyData.content.course_id,
        session_id: NotifiyData.content.session_id,
        topicId: NotifiyData.content.topic_id,
        sessionkey: 'session',
        isTA: false,
        ngbNavItem: 5,
        notification:true,
        tab_no:4}})
        

    }  else if(NotifiyData.type == 'mosaic_project'){
      this.router.navigate(['/passion-projects/view'], { queryParams:{ id:NotifiyData.content.project_id}})
    }  else if(NotifiyData.type == 'mosaic_team'){
      this.router.navigate(['/passion-projects/view'], { queryParams:{ id:NotifiyData.content.project_id}})
    } else if(NotifiyData.type == 'project_agreement'){
      this.router.navigate(['/passion-projects/view'], { queryParams:{ id:NotifiyData.content.project_id}})
    } else if(NotifiyData.type == 'marked_coursework'){
      let activeIdNav:any;
      if(NotifiyData.content.topic_id !== ''){
        activeIdNav = 1
      } else{
        activeIdNav = 7
      }
      this.router.navigate(['/courses/course-work'], { queryParams: { courseWork: NotifiyData.content.coursework_id, course_id: NotifiyData.content.course_id,course:NotifiyData.content.course_name, topic_id: NotifiyData.content.topic_id,tab_no:activeIdNav, notification:true } });
    } else if(NotifiyData.type == 'marked_assessment'){
      this.router.navigate(['/courses/feedback-assessement'] , { 
        queryParams: {
          course_id:NotifiyData.content.course_id, 
          course:NotifiyData.content.course_name,
          assessment_id:NotifiyData.content.assessment_id, 
          assessment_name:NotifiyData.content.assessment_name, 
          assessment_result_id:NotifiyData.content.assessment_result_id,
          user__id:this.user_id, 
          topicId: NotifiyData.content.topic_id, 
          session_id: NotifiyData.content.session_id,
          sessionkey:'session' ,
          isTA:false,
          notification:true 
        } 
      })
    } else if(NotifiyData.type == 'changes_by_admin'){
      this.router.navigate(['/public-profile'])
    } else if(NotifiyData.type == 'registration' && NotifiyData.content && NotifiyData.content.user_id){
      this.router.navigate(['/public-profile'], { queryParams: { student_id: NotifiyData.content.user_id } });
    } else if(NotifiyData.type == 'topic'){     
      this.router.navigate(['/courses/single-course'], { queryParams:{ course_id:NotifiyData.content.course_id, topic_id:NotifiyData.content.topic_id , tab_no:1}})
     } else if(NotifiyData.type == 'question'){     
      this.router.navigate(['/question-details'], { queryParams:{ questionId:NotifiyData.content.question_id, info:'allQus'}})
     } else if(NotifiyData.type == 'announcement'){     
      this.router.navigate(['/courses/single-course'], { queryParams:{ course_id:NotifiyData.content.course_id, tab_no:2}})
     } else if(NotifiyData.type == 'TA_students'){     
      this.router.navigate(['/courses/single-course'], { queryParams:{ course_id:NotifiyData.content.course_id, tab_no:7}})
     }else if(NotifiyData.type == 'course_coursework' || NotifiyData.type == 'coursework'){     
      this.router.navigate(['/courses/single-course'], { queryParams:{ course_id:NotifiyData.content.course_id, tab_no:7}})
     } else if(NotifiyData.type == 'coursework_invite'){  
      if(NotifiyData.content.topic_id){
        this.router.navigate(['/courses/single-course'], { queryParams:{ course_id:NotifiyData.content.course_id, tab_no:1}})
      } else{
        this.router.navigate(['/courses/single-course'], { queryParams:{ course_id:NotifiyData.content.course_id, tab_no:7}})
      }
     } else if(NotifiyData.type == 'course_assessment'){     
      this.router.navigate(['/courses/single-course'], { queryParams:{ course_id:NotifiyData.content.course_id, tab_no:6}})
     } else if(NotifiyData.type == 'assessment'){   
      if(NotifiyData.level == 'course'){
        this.router.navigate(['/courses/single-course'], { queryParams:{ course_id:NotifiyData.content.course_id,  topic_id:NotifiyData.content.topic_id, tab_no:6 }})
      }  else if(NotifiyData.level !== 'course'){
        this.router.navigate(['/courses/single-course'], { queryParams:{ course_id:NotifiyData.content.course_id,  topic_id:NotifiyData.content.topic_id, tab_no:1 }})
      }
     } else if(NotifiyData.type == 'mantee_session_visibility') {
      this.router.navigate(['/public-profile']);
    } else if(NotifiyData.type == 'mentor_session_booking') {
      this.router.navigate(['/schedules'], {queryParams:{sbi:NotifiyData.content.booking_id}});
    } else if(NotifiyData.type == 'mentor_session_reminder') {
      this.router.navigate(['/schedules'], {queryParams:{sbi:NotifiyData.content.mentor_session_id}});
     } else if(NotifiyData.type == 'mentor_webinar_invite') {
      this.router.navigate(['/schedules'], {queryParams:{sbi:NotifiyData.content.webinar_id}});
    } else if(NotifiyData.type == 'action_item_submit') {
      this.router.navigate(['/mentorship/mentorship-details'], {queryParams: {id: NotifiyData.content.session_id, type: 'one_o_one_session', ref: 'profile'}});
    } else if(NotifiyData.type == 'action_items_feedback') {
      this.router.navigate(['/mentorship/mentorship-details'], {queryParams: {id: NotifiyData.content.session_id, type: 'one_o_one_session'}});
    } else if(NotifiyData.type == 'organisation') {
      if (NotifiyData.subtype === 'student_signup' && NotifiyData.content && NotifiyData.content.user_id) {
        this.router.navigate(['/public-profile'], { queryParams: { student_id: NotifiyData.content.user_id } });
      } else {
        this.router.navigate(['/notifications']);
      }
    }

  }

  readNotifyMethod(notify_id){
    this.ns.readNotify(notify_id).subscribe((response:any)=>{
      this.getNotificationApiData();
    },error=>{
      console.log(error.message);
    })
  }

  toggleNavbar() {
    this.navbarOpen = !this.navbarOpen;
  }

  signout() {
    this.user_id = localStorage.getItem('user_id');
    this.shareService.setUserStatus('away');
    this.shareService.IsSocketTrue.subscribe((res)=>{
      let isSocketTrue = res;
      if(isSocketTrue == true){
        this.socket_service.set_user_status('away', this.user_id);    
      }
    })
    this.loginFlag = false;
    localStorage.removeItem('currentUser');
    localStorage.removeItem('token');
    localStorage.removeItem('Email_ID');
    localStorage.removeItem('user_id');
    localStorage.removeItem('role');
    localStorage.removeItem('coins');
    localStorage.removeItem('permissions');
    localStorage.removeItem('avatarURL');
    localStorage.removeItem('first_name');
    localStorage.removeItem('last_name');
    this.result = [];
    setTimeout(() => {
      this.socket_service.close_socket();
    }, 1000);
    this.router.navigate(['/login']);
  }

  findIndexOf(slug, pmenusSlug) {
    //this.route_name = this.activate_route.
    let indexOfValue;
    let Slug = pmenusSlug.split('/')
    if (Slug[1] != undefined) {
      indexOfValue = this.shareService.getIndexArr(slug, Slug[0]);
      if (indexOfValue <= -1) {
        indexOfValue = this.shareService.getIndexArr(slug, Slug[1])
      }
      return indexOfValue;
    }
    indexOfValue = this.shareService.getIndexArr(slug, pmenusSlug)
    return indexOfValue;
  }

  getLength(permissions) {
    let add_user = this.shareService.getIndexArr(permissions, "add_user");
    let report = this.shareService.getIndexArr(permissions, "report");
    let bulk_upload_mul_users = this.shareService.getIndexArr(permissions, "bulk_upload_mul_users");
    if (bulk_upload_mul_users > 0 || report > 0 || add_user > 0) {
      return '';
    } else {
      return 'none'
    }

  }
  openNotiBx() {
    this.showNotiBx = !this.showNotiBx;
  }


  
  allCoins = '';
  get loginFLagValue(): boolean {
    if (localStorage.getItem('currentUser')) {
      this.allCoins = localStorage.getItem('coins');
      return this.loginFlag = true;
    }
    this.allCoins = '';
    return this.loginFlag = false;
  }
  pageName = '';
  Get_count() {
    this.pageName = this.router.url;
    const title = this.pageName.split('/');
    let titlename = title[1];
    if (titlename == 'guftagu') {
      this.socket_service.get_notification_list = [];
      return 0
    }
    return this.socket_service.get_notification_list.length;
  }


  setCoinEvent(){    
    this.headerService.getLatestCoin().subscribe((apiResponse)=>{
      localStorage.setItem("coins", apiResponse.coins);
      this.userFirstName = localStorage.getItem('first_name');
      this.userLastName = localStorage.getItem('last_name');
    })
  }


  sidebarMainMenu: boolean = false;
  mainMenuClickEvent() {
    this.sidebarMainMenu = !this.sidebarMainMenu;
  }

  navigate_to(url) {
    this.ns.navigate_to(url);
  }

  navigate_too(url, category_id) {
    // console.log(url, course_id);
    this.ns.navigate_wirh_id(url, category_id)
    this.sortedCourseCategory();
  }




  // loader = false;
  // sotedCategory: string[];

  // sortedCourseCategory() {
  //   this.loader = true;
  //   this.courseService.sortedCourseCategory().pipe(finalize(() => {
  //     this.loader = false;
  //   })).subscribe((data: any) => {
  //     this.sotedCategory = data;
  //   });
  // }
  sotedCategory;
  sortedCourseCategory(): void {
    if (this.role == 'student') {
      this.cateLoader = true;
      this.courseService.sortedCourseCategory().subscribe(
        (data) => {
          this.sotedCategory = data;
          this.cateLoader = false;
          //console.log(data)
          // if (this.role == 'student') {
          //   return false;
          // }
        },error => {
          this.cateLoader = false;
          console.error('Error fetching sorted course categories:', error);
        }
      )
    }
  }


  loader = false
  onTopChangeCategory(cat_id) {
    this.router.navigate(['/category-list'], { queryParams: { course_category_id: cat_id, } })


  }


  sentToPublicProfile(value) {
    this.route.navigate(['/public-profile'])
  }

  search_text: any = '';
  searchType: any = 'question'

  onSearchTextChanged(searchVal) {
    //this.shareService.searchedText.next(searchVal);
    // console.log(searchVal.target.value)
    //this.route.navigate(['/search']);
  }

  //FOR SEARCH WITH QUERY PARAM
  ngAfterViewInit() {
    if(this.searchInput) {
      fromEvent(this.searchInput.nativeElement,'input')
          .pipe(
              //filter(Boolean),
              debounceTime(400),
              distinctUntilChanged(),
              tap((event) => {
                let searchVal = event;
                let searchPath = '/search';
                if(this.searchInput.nativeElement.value.length > 0){
                  searchPath = 'search?q='+this.searchInput.nativeElement.value;
                }
                this.router.navigateByUrl(searchPath);
              })
          )
          .subscribe();
    } 
    this.changeDetector.detectChanges();
  }


  // inputValue: string
  // isAssAvailable: boolean = false;
  // searchGlobal(ev: any) {
  //   this.roles = localStorage.getItem('role');
  //   if (this.roles === 'student') {
  //     // set val to the value of the searchbar
  //     let valP = ''
  //     if (typeof ev == "string") {
  //       valP = ev.toLowerCase();
  //       this.inputValue = ev.toLowerCase();
  //     } else {
  //       valP = ev.target.value.toLowerCase();
  //       this.inputValue = ev.target.value.toLowerCase();
  //     }
  //     // if the value is an empty string don't filter the items
  //     if (valP && valP.trim() != '') {
  //       valP = ev.target.value.toLowerCase();
  //       this.inputValue = ev.target.value.toLowerCase();
  //       console.log(this.inputValue)
  //       // this.onInput(this.inputValue)
  //       // this.fetchAssMent(valP)
  //       // this.isAssAvailable = true;
  //     } else {
  //       console.log('else', this.inputValue)

  //       // this.isAssAvailable = false;
  //       // this.fetchAssessments();
  //     }
  //   }
  // }

  //FOR STICKY HEADER |START
  @HostListener('window:scroll', [])
    onWindowScroll() {
      const headerElm = this.headerSection.nativeElement;
      const headerElmHeight = headerElm.offsetHeight;
      if(window.pageYOffset > headerElmHeight)
      {
        this.renderer.addClass(headerElm, 'sticky');
      }
      else
      {
        this.renderer.removeClass(headerElm, 'sticky');
      }
    }
    //FOR STICKY HEADER |END

    
    lasestCount(){
      this.shareService.getCountItem.subscribe((res)=>{        
        this.countNumber = res;
        // console.log(res);
        
        
      })
    }

    isAccept:boolean = false
    isdeclined:boolean = false
    send_to:string = null;
    receive_request(pc, answer) {
      // console.log(pc)
      let send_by = localStorage.getItem('user_id');
      this.send_to = pc.content.sender_id;
  
      let view_room: any[];
      this.socket_service.Accept_decline(send_by, this.send_to, answer).subscribe(res => {
        view_room = res.message;
        if (answer == 'accept') {
          this.isAccept = true;
          this.isdeclined = false;
          this.ns.showNotification('success', "Thank you for accepting the request. Let's chat!");
        } else if (answer == 'decline') {
          this.isAccept = false;
          this.isdeclined = true;
          this.ns.showNotification('success', 'No worries, Thank you!');
        }
      },
        (err) => {
  
        })
    }

  ngDoCheck(){
    this.countNumber = localStorage.getItem('unread_msg');
    this.globalMessageCount = this.getGlobalMessageCount();
  }

  getGlobalMessageCount() {
    return Number(localStorage.getItem(this.globalMessageCountStorageKey) || '0');
  }

  resetMessageCount(){  
    localStorage.removeItem('unread_msg')
    this.countNumber = 0;
  }
 navigateToJobHeader() {
  const path = '/job-portal/add-job/job-header';
  this.router.navigate([path])
    .then(success => {
      if (!success) {
        console.warn('Navigation failed, redirecting to job portal.');
        this.router.navigate(['/job-portal']);
      }
    })
    .catch(err => {
      console.error('Navigation error:', err);
      this.router.navigate(['/job-portal']);
    });
}

  /**
   * To unsubscribe subscriptions
   */
  ngOnDestroy() {
    this.orgLogoSubs.unsubscribe();
  }
  
}
